import { render } from "./painScale.vue?vue&type=template&id=49859640&lang=true"
import script from "./painScale.vue?vue&type=script&lang=js"
export * from "./painScale.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__